import React, { useEffect } from 'react'
import ConfigureMaskInput, { GeraDataMaskKey } from '../mask';
import InputBaseSmall from '~/components/InputBase/small';

const InputSmall = React.forwardRef(({
    mask = '',
    ...props
}, ref) => {

    const key = GeraDataMaskKey();

    useEffect(() => {

        /**
         * Configura as máscaras.
         */
        ConfigureMaskInput(mask, key);

    }, []);

    return (
        <>
            <InputBaseSmall
                ref={ref}
                {...(mask ? { "data-mask-key": key } : {})}
                {...props}
            />
        </>
    )

});

export default InputSmall;
